var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "23.518 4.241 64 102.554",
    width: 64,
    height: 102.554,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.41 106.795a13.1 13.1 0 0 1-9.272-3.836L27.355 65.176a13.1 13.1 0 0 1-3.817-9.639 13.1 13.1 0 0 1 3.817-9.658L65.137 8.077a13.1 13.1 0 0 1 9.273-3.836 13.128 13.128 0 0 1 9.272 22.381L54.786 55.518l28.896 28.896a13.11 13.11 0 0 1 0 18.545 13.1 13.1 0 0 1-9.272 3.836m0-96.386a6.94 6.94 0 0 0-4.916 2.024L32.443 50.236c-1.369 1.369-1.292 3.219-1.292 5.166v.231c0 1.966-.096 3.798 1.292 5.166l37.436 37.783a6.55 6.55 0 0 0 4.723 2.024 6.75 6.75 0 0 0 4.819-2.024 6.94 6.94 0 0 0-.039-9.812L48.251 57.696a3.084 3.084 0 0 1-.019-4.357l31.094-31.094a6.94 6.94 0 0 0 0-9.812 6.94 6.94 0 0 0-4.916-2.023"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.724943ab2887591b4ef2dc0c20610de5.svg";
export { ForwardRef as ReactComponent };